import React, { CSSProperties, useCallback } from 'react'
import useFindRouteByPath from 'src/hooks/useRouteToMetaData.hook'
import usePageNav from 'src/hooks/usePageNav.hook'
import { useLocation } from 'react-router-dom'
import usePathMatch from 'src/hooks/usePathMatch.hook'
import { HeaderView } from 'src/components/layout/Header/view'
import { useGlobalStore } from 'src/store/zustand'

export type HeaderImgType = 'back' | 'text_logo' | 'search_user'

export type HeaderBtnType = 'gifted_coupon'

export interface HeaderImg {
  src: string
  style?: CSSProperties
  func: () => void
}

export interface HeaderBtn {
  src: string
  func: () => void
}

export interface HeaderProps {
  text?: React.ReactNode
  rightBtn?: HeaderBtn[]
  rightImg?: HeaderImg[]
  leftImg?: HeaderImg[]
  /** `/join/cert` 비가입(약관) 단계 등 — 헤더 가운데 제목 영역 넓힘 */
  joinCertGuestLayout?: boolean
}

const Header = () => {
  const { mainPageNav, searchPageNav, myPageNav, navigatePrev, giftedCouponPageNav } = usePageNav()
  const textLogo = `${process.env.PUBLIC_URL}/images/text_logo.svg`
  const backIcon = `${process.env.PUBLIC_URL}/images/arrow_back_icon.svg`
  const searchIcon = `${process.env.PUBLIC_URL}/images/search_icon.svg`
  const useIcon = `${process.env.PUBLIC_URL}/images/user_icon.svg`

  const { state, pathname } = useLocation()
  const { isHeader } = useFindRouteByPath()
  const { match_brand_detail, match_join_cert } = usePathMatch()
  const { resetBrandUnderLineTab, joinCertHeaderTitleOverride } = useGlobalStore()

  const headerData = useCallback(() => {
    const isBackMainException =
      (pathname.includes('/gift/gifted_coupon') || pathname.includes('/coupon/purchase_history')) &&
      window.history.length <= 1

    const textToImg: Record<HeaderImgType, HeaderImg[]> = {
      back: [
        {
          src: backIcon,
          func: () => {
            if (isBackMainException) {
              mainPageNav()
            } else {
              match_brand_detail && resetBrandUnderLineTab()
              navigatePrev()
            }
          },
          style: { marginLeft: '10px' },
        },
      ],
      search_user: [
        { src: searchIcon, func: searchPageNav },
        { src: useIcon, func: myPageNav, style: { marginRight: '-28px' } },
      ],
      text_logo: [{ src: textLogo, func: mainPageNav, style: { marginLeft: '20px' } }],
    }

    const textToBtn: Record<HeaderBtnType, HeaderBtn[]> = {
      gifted_coupon: [{ src: '선물한 쿠폰', func: giftedCouponPageNav }],
    }

    const metaTitle = match_brand_detail ? state?.brandName : isHeader?.text

    const text =
      match_join_cert && joinCertHeaderTitleOverride ? joinCertHeaderTitleOverride : metaTitle

    const joinCertGuestLayout = match_join_cert && !!joinCertHeaderTitleOverride

    return {
      leftImg: textToImg[isHeader?.leftImg as HeaderImgType],
      rightImg: textToImg[isHeader?.rightImg as HeaderImgType],
      text,
      rightBtn: textToBtn[isHeader?.rightBtn as HeaderBtnType],
      joinCertGuestLayout,
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHeader, pathname, joinCertHeaderTitleOverride, state?.brandName, match_brand_detail])

  if (isHeader === undefined) {
    return null
  }

  const props: HeaderProps = {
    ...headerData(),
  }

  return <HeaderView {...props} />
}

export default Header
